import { CompanyValidationSchema } from "@/components/pages/Settings/validation/companyValidationSchema";
import * as z from "zod";

const invoicingValidationSchema = CompanyValidationSchema.pick({
  invoiceemail: true,
  alwaysInvoice: true,
}).extend({
  invoiceemail: z.string().email({ message: "validation:emailRequired" }),
  alwaysInvoice: z.boolean(),
});

export const InvoicingValidationSchema = invoicingValidationSchema;
export type InvoicingFormInput = z.infer<typeof invoicingValidationSchema>;
